import { render, staticRenderFns } from "./LiveDataPlatformTable.vue?vue&type=template&id=2a86846d&scoped=true"
import script from "./LiveDataPlatformTable.vue?vue&type=script&lang=js"
export * from "./LiveDataPlatformTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a86846d",
  null
  
)

export default component.exports